(function () {
    'use strict';

    angular.module('app').factory('cancelClearanceDialog', CancelClearanceDialogFactory);

    CancelClearanceDialogFactory.$inject = ['$rootScope', '$timeout', '$document', 'cancelClearance', 'habilEnabledFeatures', 'userFunctions'];
    function CancelClearanceDialogFactory($rootScope, $timeout, $document, cancelClearance, habilEnabledFeatures, userFunctions) {
        const features = habilEnabledFeatures;
        const sendButtonId = "send-form";
        const $dialogScope = $rootScope.$new(true);
        const userIsAso = userFunctions.currentUserHasRole("VO-ASO");

        const soCancelClearanceReasons = "SO_CANCEL_CLEARANCE_REASONS";

        return {
            sendDeactivationClearanceToNsa,
        };

        function isCancelClearanceReasonsFeatureEnabled() {
            return features.some(f => f == soCancelClearanceReasons);
        }

        function sendDeactivationClearanceToNsa(vm, clearance) {
            if (isCancelClearanceReasonsFeatureEnabled()) {
                sendWithReason(vm, clearance);
            } else {
                sendWithText(vm, clearance);
            }
        }

        function sendWithReason(vm, clearance) {
            $dialogScope.vm = vm;

            const reasonCustomDialogButtons = {
                send: {
                    id: sendButtonId,
                    label: vm.getTranslation("Button_Confirm"),
                    className: "btn-primary disabled",
                    callback: () => {
                        const reason = {
                            RequestId: clearance.RequestPublicId,
                            ReasonId: $dialogScope.vm.model.SelectedReason?.PublicId,
                            AdditionalReasonText: $dialogScope.vm.model.SelectedReason?.FreeTextRequired && $dialogScope.vm.model.ReasonText
                                ? $dialogScope.vm.model.ReasonText
                                : null
                        };
                        submitReason(vm, clearance, reason);
                    },
                    disabled: true
                },
                cancel: {
                    label: vm.getTranslation("Button_Cancel"),
                    className: "btn-default"
                }
            };

            vm.model = {};
            vm.reasonCustomDialogButtons = reasonCustomDialogButtons;

            loadReasons(vm)
                .then(() => {
                    if (userIsAso) {
                        return vm.Dialog.Confirm(getConfirmationText(vm, vm.getTranslation("AreYouSureToDeactivateClearance")));
                    }
                })
                .then(() => requireMotivation(vm))
                .catch(angular.noop);
        }
            
        function requireMotivation(vm) {
            $dialogScope.vm.OnReasonChange = () => onReasonChange(vm);

            watchFormState(vm);

            const cancelClearanceReasonCustomDialogOptions = {
                templateUrl: "@/ivm/cancel-clearance-reasons-template.html",
                scope: $dialogScope,
                size: "large",
                onEscape: true,
                title: `Habil+ | ${vm.getTranslation("DeactivateClearance")}`,
                buttons: vm.reasonCustomDialogButtons,
            };
            return vm.Dialog.Custom(cancelClearanceReasonCustomDialogOptions);
        }

        function loadReasons(vm) {
            return new Promise((resolve, reject) => {
                cancelClearance.GetCancelClearanceReasons(
                    {},
                    (result) => {
                        if (!CheckResultReceived(result)) {
                            vm.ShowError(result);
                            reject();
                            return;
                        }

                        $dialogScope.vm.Reasons = result.data;
                        $dialogScope.vm.model = {};
                        $dialogScope.vm.ReasonsList = result.data.map(r => ({ Key: r.PublicId, Value: r.Reason }));
                        resolve();
                    },
                    (err) => {
                        vm.ShowError(err);
                        reject();
                    }
                );
            });
        }

        function submitReason(vm, clearance, reason) {
            vm.SetLoadingState(true);

            vm.Api.SendClearanceDeactivationToNsa(
                {
                    RequestId: clearance.RequestPublicId,
                    Reason: reason
                },
                (result) => {
                    if (!CheckResultReceived(result)) {
                        vm.ShowError(result);
                        return;
                    }

                    removeRequestFromList(vm, clearance);

                    vm.ShowSuccess(vm.getTranslation("Person_YourRequestHasBeenTransferred"));
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }

        function sendWithText(vm, clearance) {
            vm.Dialog.Confirm(getConfirmationText(vm, vm.getTranslation("AreYouSureToDeactivateClearance")))
                .then(() => onConfirm(vm))
                .then((reasonText) => {
                    const reason = {
                        RequestId: clearance.RequestPublicId,
                        ReasonId: null,
                        AdditionalReasonText: reasonText
                    };
                    deactivate(vm, clearance, reason);
                })
                .catch(angular.noop);
        }

        function onConfirm(vm) {
            const options = {
                inputType: "textarea",
                onEscape: true,
                size: "large",
                title: `Habil+ | ${vm.getTranslation("DeactivateClearance")}`,
                message: vm.getTranslation("CancelClearanceReasons_Title"),
            };
            return vm.Dialog.Prompt(options);
        }

        function deactivate(vm, clearance, reason) {
            vm.SetLoadingState(true);

            vm.Api.SendClearanceDeactivationToNsa(
                { RequestId: clearance.RequestPublicId, Reason: reason },
                (result) => {
                    if (!CheckResultReceived(result)) {
                        vm.ShowError(result);
                        return;
                    }

                    vm.DataSource.ResetSearch();
                },
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }

        function removeRequestFromList(vm, clearance) {
            vm.DataSource.RemoveItem(clearance);
        }

        function getConfirmationText(vm, confirmationQuestion) {
            let confirmationText = confirmationQuestion;

            if (userIsAso) {
                const confirmationNeededBySo = vm.getTranslation("IVM_ConfirmationNeededBySo");
                confirmationText = `${confirmationText}<br><br><strong>${confirmationNeededBySo}</strong>`;
            }

            return confirmationText;
        }

        function canSubmitForm() {
            const model = $dialogScope.vm.model;
            if (model.SelectedReason) {
                if (model.SelectedReason.FreeTextRequired) {
                    return model.ReasonId
                        && model.ReasonText
                        && model.ReasonText.length >= 6;
                } else {
                    return model.ReasonId;
                }
            }
            return false;
        }

        function watchFormState(vm) {
            $dialogScope.$watchGroup([
                () => $dialogScope.vm.isSending,
                () => $dialogScope.vm.model['ReasonId'],
                () => $dialogScope.vm.model['ReasonText'],
                () => $dialogScope.vm.model['SelectedReason']
            ], ([isSending]) => {
                if (!vm.reasonCustomDialogButtons)
                    return;
                const buttons = angular.copy(vm.reasonCustomDialogButtons);

                const isSendingDisabled = isSending || !canSubmitForm();

                buttons.send.className = `btn-primary ${isSendingDisabled ? "disabled" : ""}`;

                const sendButton = angular.element($document[0].getElementById(sendButtonId));
                sendButton.toggleClass("disabled", isSendingDisabled);
                sendButton.attr("disabled", isSendingDisabled);
            });
        }

        function onReasonChange() {
            $timeout(function () {
                $dialogScope.vm.model.SelectedReason = $dialogScope.vm.Reasons.find(
                    reason => reason.PublicId === $dialogScope.vm.model.ReasonId
                );
                $dialogScope.vm.model.ReasonText = null;
            });
        }
    }
})();